const provider = state => state.provider;
const providers = state => state.providers;
const providerReceita = state => state.providerReceita;

const iss = state => {
  state.iss.forEach(element => {
    if (element.code)
      element.code_description = element.code + " - " + element.description;
    else element.code_description = element.description;
  });

  return state.iss;
};

const recipeCode = state => {
  state.recipeCode.forEach(element => {
    if (element.code)
      element.code_description = element.code + " - " + element.description;
    else element.code_description = element.description;
  });

  return state.recipeCode;
};

const formaPagamento = state => state.formaPagamento;

export default {
  providers,
  provider,
  providerReceita,
  iss,
  recipeCode,
  formaPagamento
};
